import React, { useEffect, useState } from 'react';
import Table from '../../../components/table';
import { useAdvanceBoolean, useBoolean, useWealthlaneCustomerApi } from '../../../hooks';
import { ModalStatusType, TableParamsType } from '../../../types/common';
import InitialValuesForm from '../../../constants/initialValues';
import { PageHeader } from '../../../constants/style/common.styled';
import Heading from '../../../components/typography';
import Search from '../../../components/search/search';
import AlertPopup from '../../../components/alert-popup';
import Button from '../../../components/button';
import AnimationWrapper from '../../../components/animation/animationWrapper';
import CompanyMapModal from './companyMapModal';
import { SettingButton } from './customerSuccess.styled';
import { CompanyMappingHeader } from '../../../constants/table-headers/companyMappingHeader';
import useGetAllAllowedCompanyMapping from '../../../hooks/get/useGetAllowedCompanyMappings';
import useDeleteAllowedMapping from '../../../hooks/delete/useDeleteAllowedMapping';
import {
  DynamicTable,
  withDynamicTableContext,
  useDynamicTable,
  useTableSchemaLoader,
} from '@wealthlane/table-builder';
import Spinners from '../../../components/spinner';
import { axiosInstance } from '../../../services/apiInterceptor';
import { ActionRegistry } from '@packages/table-builder/registry/ActionRegistry';
import { buildCompanyMappingFormDataFromRow } from '@packages/domain/shared/customer-success-options/helpers';
import { queryClient } from '@/queryClient';
import '@/apps/customer/domains/company-mapping/company-mapping.actions';

const initialValues = {
  data: InitialValuesForm.companyMapping,
  id: '',
};

const CompanyMapping = () => {
  const { handleRequest } = useWealthlaneCustomerApi();
  const [searchQuery, setSearchQuery] = useState('');
  // const [tableInfo, setTableInfo] = useState<TableParamsType>(InitialValuesForm.tableParams);
  const { tableInfo, setTableInfo } = useDynamicTable();

  useEffect(() => {
    setTableInfo(InitialValuesForm.tableParams);
  }, []);

  const {
    data: allowedCompanyMapping,
    isLoading,
    status,
  } = useGetAllAllowedCompanyMapping(handleRequest, tableInfo);

  const [modalStatus, setModalStatus] = useState<ModalStatusType>('Add');
  const [open, setOpen] = useState(false);
  const [initialData, setInitialData] = useState(initialValues);

  const { schemaData, isTableSchemaLoading } = useTableSchemaLoader({
    identifier: 'COMPANY_MAPPING_TABLE',
    baseUrl: process.env.REACT_APP_WEALTHLANE_API_ENDPOINT,
  });

  const data = React.useMemo(
    () => allowedCompanyMapping?.items || [],
    [allowedCompanyMapping, isLoading]
  );

  const {
    value: isDeleteModalOpen,
    setFalse: closeDeleteModal,
    setTrue: openDeleteModal,
    customValue: deleteId,
    setCustomValue: setDeleteId,
  } = useAdvanceBoolean<string>(false);

  const { mutate: deleteAllowedMapping, isLoading: isDeletingMapping } = useDeleteAllowedMapping(
    handleRequest,
    closeDeleteModal
  );

  const { value: isModalOpen, setFalse: closeModal, setTrue: openModal } = useBoolean(false);

  const actions = [
    {
      id: "edit",
      as: 'Edit',
      action: 'Edit',
      onClick: (id: string, rowData: any) => {
        const formIds = buildCompanyMappingFormDataFromRow(rowData) ?? {};
        ActionRegistry.emitIntent({
          type: 'OPEN_COMPOSE_MODAL',
          actionId: 'BUILD_COMPANY_MAPPING_FORM',
          context: {
            pk: id,
            row: rowData,
            params: { id, ...formIds },
            refreshTable: () => queryClient.invalidateQueries('getAllAllowedCompanyMappings'),
            meta: {
              title: 'Edit Company Mapping',
              entity: 'CompanyMapping',
              size: 'sm',
              semanticId: 'editCompanyMappingModal',
              mode: 'edit',
            },
          },
        });
      },
    },
    {
      id: "delete",
      as: 'Delete',
      action: <div className='delete-label'>Delete</div>,
      onClick: (id: string) => {
        openDeleteModal();
        setDeleteId(id);
      },
    },
  ];

  const onDeletePrimaryClick = (values: Record<string, any>): void => {
    deleteAllowedMapping(deleteId);
  };

  const renderRightToolbarButton = () => {
    return (
      <Button
        as='Create'
        id='addMappingButton'
        variant={'primary'}
        title={'Add Mapping'}
        icon={'add_circle_outline'}
        onClick={() => {
          ActionRegistry.emitIntent({
            type: 'OPEN_COMPOSE_MODAL',
            actionId: 'BUILD_COMPANY_MAPPING_FORM',
            context: {
              pk: '',
              params: {},
              refreshTable: () => queryClient.invalidateQueries('getAllAllowedCompanyMappings'),
              meta: {
                title: 'Add Mapping',
                entity: 'CompanyMapping',
                size: 'sm',
                semanticId: 'addCompanyMappingModal',
                mode: 'create',
              },
            },
          });
        }}
      />
    );
  };

  const schema = React.useMemo(
    () => ({
      columns: CompanyMappingHeader({ actions: schemaData?.columns, tableActions: actions }),
      options: schemaData?.options as any,
    }),
    [schemaData]
  );

  if (isTableSchemaLoading) return <Spinners containerClassName='h-screen' />;

  return (
    <div data-page="companyMapping" id="pageContainer">
      <PageHeader id="pageHeader">
        <Heading variant='h3' title='Companies' id="pageTitle" />
        <Heading variant='body-s' title=' List of companies for mapping.' id="pageDescription" />
      </PageHeader>
      {/* <div className='grid items-start gap-5 xl:grid-cols-12 mb-6'>
        <div className='grid gap-2 xl:col-span-10 lg:grid-cols-10 '>
          <div className='col-span-2 lg:col-span-6 flex lg:gap-1.5'> */}
      {/* <div className='col-span-6 lg:col-span-2'>
              <Search
                placeholder='Search'
                searchValue={searchQuery}
                onSearch={(value: string) => {
                  setSearchQuery(value);
                }}
                setTableInfo={setTableInfo}
                tableInfo={tableInfo}
              />
            </div> */}
      {/* <Filter setOpen={setOpen} open={open} className='gap-5'>
              <Heading variant='body-xs' title={'Filter By:'} className={'filter-label'} />
              <div className='grid sm:grid-cols-2 gap-x-5'>
                <FormSelect
                  type='text'
                  name='companyName'
                  placeholder='Company Name'
                  onChange={(value: string) => {
                    setTableInfo({ ...tableInfo, taxPeriodId: value });
                  }}
                  options={[]}
                  values={tableInfo.taxPeriodId}
                  arrValue={tableInfo.taxPeriodId}
                  isFormik={false}
                />
              </div>
            </Filter>

            <div className='items-start sm:col-span-6 lg:col-span-2 gap-x-1'>
              <ResetFilterWrapper
                className='flex justify-center'
                onClick={() => {
                  setTableInfo(InitialValuesForm.tableParams);
                  setSearchQuery('');
                }}
              >
                <span className='material-symbols-outlined'>settings_backup_restore</span>
                <Heading variant='body-s' title='Reset Filter' />
              </ResetFilterWrapper>
            </div> */}
      {/* </div>
        </div> */}
      {/* <SettingButton className='flex justify-start xl:col-span-2 lg:justify-end'>
          <Button
            as='Create'
            variant={'primary'}
            title={'Add Mapping'}
            icon={'add_circle_outline'}
            onClick={() => {
              setModalStatus('Add');
              openModal();
            }}
          />
        </SettingButton> */}
      {/* </div> */}

      {isDeleteModalOpen && (
        <AlertPopup
          id="companyMappingAlert"
          isShow={isDeleteModalOpen}
          closeModal={closeDeleteModal}
          customTitle={'Are you sure you want to delete Mapping?'}
          handleSubmit={onDeletePrimaryClick}
          loading={isDeletingMapping}
        />
      )}
      <AnimationWrapper>
        {isModalOpen && (
          <CompanyMapModal
            id='companyMappingModal'
            isModalOpen={isModalOpen}
            closeModal={() => {
              closeModal();
              setInitialData({
                data: InitialValuesForm.companyMapping,
                id: '',
              });
            }}
            modalStatus={modalStatus}
            setModalStatus={setModalStatus}
            loading={false}
            initialValue={initialData}
            handleRequest={handleRequest}
          />
        )}
      </AnimationWrapper>
      {/* <Table
        columns={CompanyMappingHeader(actions)}
        data={allowedCompanyMapping?.items ?? []}
        loading={status}
        showPagination={true}
        totalCounts={allowedCompanyMapping?.totalCount ?? 10}
        tableInfo={tableInfo}
        setTableInfo={setTableInfo}
      /> */}
      <DynamicTable
        id="dataTable"
        schema={schema}
        data={data}
        totalCounts={allowedCompanyMapping?.totalCount ?? 10}
        loading={status}
        components={{
          renderRightToolbarButton,
        }}
      />
    </div>
  );
};

export default withDynamicTableContext(CompanyMapping, false, axiosInstance);
